import React from 'react'
import { render } from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import './index.css';
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import App from './components/App'
import reducer from './reducers'
import './i18n'

import * as firebase from 'firebase'

// Initialize Firebase
let config = {
    apiKey: "AIzaSyDWBCdyqpkFGJzO-IfXixI4UQv0zxFJLrA",
    authDomain: "findar-514d2.firebaseapp.com",
    databaseURL: "https://findar-514d2.firebaseio.com",
    projectId: "findar-514d2",
    storageBucket: "findar-514d2.appspot.com",
    messagingSenderId: "968241721917"
};
firebase.initializeApp(config)

const middleware = [ thunk ]
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger())
}

const store = createStore(
  reducer,
  applyMiddleware(...middleware)
)

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js